import { parkStats } from '../../../mocks/parks';

export default function StatsBar() {
  // Guard against missing or malformed data
  if (!Array.isArray(parkStats) || parkStats.length === 0) {
    return (
      <section className="py-10 bg-gradient-to-r from-teal-600 to-emerald-600">
        <div className="max-w-7xl mx-auto px-6 text-center text-white">
          No statistics available.
        </div>
      </section>
    );
  }

  return (
    <section className="py-10 bg-gradient-to-r from-teal-600 to-emerald-600">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {parkStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                <i className={`${stat.icon} text-emerald-200 text-2xl`}></i>
              </div>
              <div className="text-3xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-teal-100 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
        
        {/* Source Attribution */}
        <div className="text-center mt-6 pt-6 border-t border-teal-500/30">
          <p className="text-teal-100 text-sm">
            Data provided by City of Roseville Parks & Recreation Department
          </p>
          <p className="text-teal-200/50 text-xs mt-1">
            <i className="ri-time-line mr-1"></i>Data last updated: January 15, 2025
          </p>
        </div>
      </div>
    </section>
  );
}